var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('FButtonSection',{attrs:{"href":"https://clienteseguro.multipluscard.com.br/jmvtef","icon":"credit_card","title":"Conciliador TEF","descr":"Controle de operações do cartão TEF"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }